import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getNotifications: (input) => ({
    url: 'notification/api/v1/inbox',
    method: 'GET',
    params: input,
  }),
  getNotification: ({ id }) => ({
    url: `notification/api/v1/inbox/${id}`,
    method: 'GET',
  }),
  seenNotification: (input) => ({
    url: 'notification/api/v1/inbox/seen',
    method: 'POST',
    data: input,
  }),
  getMessages: (input) => ({
    url: 'notification/api/v1/inbox/messages',
    method: 'GET',
    params: input,
  }),
};

export default apis;
